import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';
import FavoriteList from '../../components/Sales/favoriteList';
import {
  addNewCustomerFavorite,
  fetchCustomersWithFavorites,
  fetchCustomerFavorites,
  selectCustomerFavorites,
  resetCurrentCustomerFavorites,
  deleteCustomerFavorite } from '../../actions/favoriteList_actions';
import {
  fetchFavoriteList,
  saveFavoriteList
} from '../../actions/favorites_actions';
import { setSaleRowValue, setValue } from '../../actions/sales_actions';
import { fetchInventories } from '../../actions/inventories_actions';

const favoriteList = reduxForm({
  form: 'favoriteList',
  destroyOnUnmount: false
})(FavoriteList);

const selector = formValueSelector('favoriteList');

function mapStateToProps(state) {
  const SearchType = selector(state, 'SearchType');
  const ProductInformation = selector(state, 'ProductInformation');

  return {
    SearchType,
    ProductInformation,
    initialValues: { SearchType: 'RefNum' },

    customers: state.customerFavorites.customersWithFavorites,
    customersIsLoading: state.customerFavorites.customersWithFavoritesIsLoading,
    customersError: state.customerFavorites.customersWithFavoritesError,
    isSaving: state.customerFavorites.isLoading,
    saveError: state.customerFavorites.error,
    userPermissions: state.auth.userPermissions,

    favoriteList: state.favorites.favoriteList,
    favoriteListIsLoading: state.favorites.favoriteListIsLoading,
    favoriteListError: state.favorites.favoriteListError,

    saveFavoriteListSuccess: state.favorites.saveFavoriteListSuccess,
    saveFavoriteListError: state.favorites.saveFavoriteListError,
  };
}

export default connect(mapStateToProps, {
  addNewCustomerFavorite,
  fetchCustomerFavorites,
  selectCustomerFavorites,
  resetCurrentCustomerFavorites,
  fetchCustomersWithFavorites,
  deleteCustomerFavorite,
  setSaleRowValue,
  setValue,
  fetchInventories,
  saveFavoriteList,
  fetchFavoriteList })(favoriteList);



// WEBPACK FOOTER //
// ./master/jsx/containers/Sales/favoriteList.jsx